












import { Component, Vue, Prop, Watch, Model, Provide, Emit } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
    private menu = false

    private valueInternal: string = "";

    @Prop() public value : any
    @Prop() public min: any
    @Prop() public max: any
    @Prop() public label: any
    @Prop() public errors: any
    @Prop() public rules: any

    private onDateInput() {
        const menu = this.$refs.menu as any
        menu.save(this.valueInternal)
        this.menu = false
    }

    public mounted() {
        this.valueInternal = this.value;
    }

    @Watch("value")
    public onValueChanged(value: string) {
        this.valueInternal = value;
    }

    @Watch("valueInternal")
    private onDateChange() {
        this.$emit("input", this.valueInternal)
    }
}
